
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-home-line',
      title: '不動産売買',
      description: 'マンション・一戸建て・土地の売買仲介。豊富な実績と地域密着のネットワークで、最適な取引をサポートします。',
      features: ['売却査定', '購入相談', '住宅ローン相談', 'アフターサポート']
    },
    {
      icon: 'ri-key-line',
      title: '賃貸仲介',
      description: '賃貸物件の仲介から管理まで。お客様のライフスタイルに合った理想の住まいをご提案いたします。',
      features: ['物件紹介', '契約サポート', '入居手続き', '更新手続き']
    },
    {
      icon: 'ri-building-line',
      title: '不動産管理',
      description: 'オーナー様の大切な資産を適切に管理。入居者募集から日常管理まで、トータルサポートいたします。',
      features: ['入居者募集', '家賃管理', 'メンテナンス', '資産価値向上']
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            サービス案内
          </h2>
          <p className="text-lg text-gray-600">
            お客様のニーズに合わせた幅広いサービスをご提供
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-blue-600`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              
              <p className="text-gray-600 mb-6">
                {service.description}
              </p>
              
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-blue-600 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
              
              <button className="mt-6 text-blue-600 font-medium hover:text-blue-700 transition-colors cursor-pointer">
                詳しく見る <i className="ri-arrow-right-line ml-1"></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
